module.exports = __webpack_public_path__ + "static/media/myLessonGreyIcon.6a5742ef.svg";